var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',[_c('b-field',[_c('b-input',{model:{value:(_vm.searchClause),callback:function ($$v) {_vm.searchClause=$$v},expression:"searchClause"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }